import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import user from './user';
import cart from './cart';
import finder from './finder';
import national from './national';

const vuexLocal = new VuexPersistence({
  key: 'assemble-sports-user',
  storage: window.localStorage,
  modules: ['user', 'cart', 'national', 'finder'],
});

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    globalLoading: false,
    loadingText: 'Loading...',
    loginRedirect: undefined
  },
  mutations: {
    loading(state, data) {
      state.globalLoading = data.loading;
      state.loadingText = data.text;
    },
    loginRedirect(state, payload) {
      state.loginRedirect = payload;
    },
  },
  actions: {
  },
  getters: {
    isGlobalLoading(state) {
      return state.globalLoading;
    },
  },
  modules: {
    user,
    cart,
    finder,
    national
  },
  plugins: [vuexLocal.plugin],
});
